import {
    INIT_TOOLTIP,
    SWITCH_TOOLTIP,
    UPDATE_TOOLTIP
} from './actions';

const initialState = {
    data: []
};

export default function reduser(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case INIT_TOOLTIP:
            return {
                ...state,
                data: [...state.data, {
                    ...payload,
                    show: false
                }]
            };
        case SWITCH_TOOLTIP:
            return {
                ...state,
                data: state.data.map((tooltip) => {
                    if (tooltip.id === payload) {
                        return { ...tooltip, show: !tooltip.show };
                    }
                    return { ...tooltip, show: false };
                })
            };
        case UPDATE_TOOLTIP:
            return {
                ...state,
                data: state.data.map((tooltip) => {
                    if (tooltip.name === payload.name) {
                        return { ...tooltip, text: payload.text };
                    }
                    return tooltip;
                })
            };
        default:
            return state;
    }
}
